// Derives a teacher-facing summary from the raw signals array emitted during a Try Mitraa demo session.
export function deriveTeacherView(signals) {
  const topicActivations = signals.filter((s) => s.type === "topic_activated");
  const attemptSignals = signals.filter((s) => s.type === "attempt_recorded");
  const attempts = attemptSignals.filter((s) => s.kind === "practice");

  const warmupBySubTopic = {};
  attemptSignals
    .filter((s) => s.kind === "warmup")
    .forEach((s) => {
      const subTopic = s.question?.sub_topic;
      if (!subTopic) return;
      if (!warmupBySubTopic[subTopic]) warmupBySubTopic[subTopic] = [];
      warmupBySubTopic[subTopic].push(!!s.result?.is_correct);
    });
  const warmupResults = Object.entries(warmupBySubTopic).map(([subTopic, results]) => ({
    subTopic,
    passed: results.every(Boolean),
  }));

  const subjectBreakdown = {};
  attemptSignals.forEach((s) => {
    const subject = s.question?.subject;
    if (!subject) return;
    if (!subjectBreakdown[subject]) subjectBreakdown[subject] = { correct: 0, total: 0 };
    subjectBreakdown[subject].total += 1;
    if (s.result?.is_correct) subjectBreakdown[subject].correct += 1;
  });

  const elapsedList = attempts.map((s) => s.elapsedMs).filter((v) => typeof v === "number");
  const avgTimeSeconds = elapsedList.length
    ? Math.round((elapsedList.reduce((a, b) => a + b, 0) / elapsedList.length / 1000) * 10) / 10
    : 0;

  const lastSignal = signals[signals.length - 1];
  const lastTopicComplete = lastSignal && lastSignal.type === "topic_complete" ? lastSignal : null;

  const lastTopicActivatedIndex = signals.reduce((acc, s, i) => (s.type === "topic_activated" ? i : acc), -1);
  const currentTopicSignals = lastTopicActivatedIndex >= 0 ? signals.slice(lastTopicActivatedIndex + 1) : signals;
  const currentTopicAttempts = currentTopicSignals.filter((s) => s.type === "attempt_recorded" && s.kind === "practice");

  return { topicActivations, warmupResults, attempts, subjectBreakdown, avgTimeSeconds, lastTopicComplete, currentTopicAttempts };
}
